import React from "react";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/userProfileApproval/UserProfile.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { profileBaseURL, baseURL } from '../../../Services/config/apiGateway';
import { PROFILEAPPROVAL, PROFILEAPPROVALHISTORY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {successLoader,} from '../../../redux/_actions/loader.action';
import { success } from '../../../redux/_actions/userProfile.action';
import { store } from '../../../redux/_helpers/store';
import { Link } from "react-router-dom";
toast.configure()
let viewOnly = false;
class UserProfile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            details: [],
            currentPage: 1,
            todosPerPage: 5,
            search: "",
            searchlength: 0,
            details1: [],
            detailsClosed1: [],
            openSide: true,
            closedSide: false,
            taskId: [],
            detailsClosed: [],
            currentClosedPage: 1,
            todosClosedPerPage: 5,
            workflowIndex: '',
            hasOpenPendingItem: false,
            indexclosed: [],
        }
        this.handleOpenClick = this.handleOpenClick.bind(this);
        this.handleOpenPrevious = this.handleOpenPrevious.bind(this);
        this.handleClosedClick = this.handleClosedClick.bind(this);
        this.handleClosedPrevious = this.handleClosedPrevious.bind(this);
        this.handlechange = this.handlechange.bind(this);
        this.handleOpenSide = this.handleOpenSide.bind(this);
        this.handleClosedSide = this.handleClosedSide.bind(this);
    }
    componentDidMount() {
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 14) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            profileBaseURL + PROFILEAPPROVAL,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    data = data.sort(function (a, b) { return new Date(b.taskData.profileUpdateRequest.submitDate).getTime() - new Date(a.taskData.profileUpdateRequest.submitDate).getTime() })
                    console.log(data)
                    this.setState({
                        details: data.map((i, index) => (
                            data[index].taskData.profileUpdateRequest = JSON.parse(data[index].taskData.profileUpdateRequest)
                        ))
                    })
                    this.state.details.sort(function (a, b) {
                        return (new Date(b.submitDate).getTime() - new Date(a.submitDate).getTime());
                    });
                    data = data.sort(function (a, b) { return new Date(b.taskData.profileUpdateRequest.submitDate).getTime() - new Date(a.taskData.profileUpdateRequest.submitDate).getTime() })
                    this.setState({ taskId: data.map((i, index) => (data[index].taskId)) })
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
        // CLOSED TAB API
        ApiCall(
            'GET',
            baseURL + PROFILEAPPROVALHISTORY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    
                    data.sort(function (a, b) {
                        return (new Date(b.approvalDate).getTime() - new Date(a.approvalDate).getTime());
                    });
                    this.setState({ detailsClosed: data
                    })
                    store.dispatch(successLoader(true));
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    handleOpenClick() {
        if (this.state.currentPage < Math.ceil(this.state.details1.length / this.state.todosPerPage)) {
            this.setState({
                currentPage: this.state.currentPage + 1,
            });
        }
    }
    handleOpenPrevious() {
        if (this.state.currentPage >= 2) {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
        }
    }
    handleClosedClick() {
        if (this.state.currentClosedPage < Math.ceil(this.state.detailsClosed.length / this.state.todosClosedPerPage)) {
            this.setState({
                currentClosedPage: this.state.currentClosedPage + 1
            });
        }
    }
    handleClosedPrevious() {
        if (this.state.currentClosedPage >= 2) {
            this.setState({
                currentClosedPage: this.state.currentClosedPage - 1
            });
        }
    }
    handlechange = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e.target.value.length
        });
        if (this.state.openSide == true) {
            this.setState({ currentPage: 1 })
        }
        else if (this.state.closedSide == true) {
            this.setState({ currentClosedPage: 1 })
        }
    };
    handleOpenSide = () => {
        this.setState({
            openSide: true,
            closedSide: false
        });
        document.getElementById('open').style.borderBottom = "3px solid #a7a7a7";
        document.getElementById('closed').style.borderBottom = "none";
    };
    handleClosedSide = () => {
            if(this.state.detailsClosed.length === 0){
                store.dispatch(successLoader(false));
    }
        this.setState({
            openSide: false,
            closedSide: true
        });
        document.getElementById('closed').style.borderBottom = "3px solid #a7a7a7";
        document.getElementById('open').style.borderBottom = "none";
    };
    getDate = (timeStamp) => {
        let date = new Date(timeStamp).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    compareObjects(object1, object2, key) {
        const obj1 = object1[key]
        const obj2 = object2[key]
        console.log(obj1, obj2, "dd", object1, object2)
        if (obj1 > obj2) {
            return -1
        }
        if (obj1 < obj2) {
            return 1
        }
        return 0
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="col1" className="tableHeading">Full Name</td>
                    <td id="col2" className="tableHeading">Mobile Number</td>
                    <td id="col3" className="tableHeading">Email Address</td>
                    <td id="col4" className="tableHeading">Role Type</td>
                    <td id="col5" className="tableHeading">Role Name</td>
                    <td id="col6" className="tableHeading">Submitted On</td>
                    <td id="col7" className="tableHeading">Status</td>
                </tr>
            </>
        )
    }
    renderClosedTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="col1" className="tableHeading">Full Name</td>
                    <td id="col2" className="tableHeading">Mobile Number</td>
                    <td id="col3" className="tableHeading">Email Address</td>
                    <td id="col4" className="tableHeading">Role Type</td>
                    <td id="col5" className="tableHeading">Role Name</td>
                    <td id="col6" className="tableHeading">Acted On</td>
                    <td id="col7" className="tableHeading">Status</td>
                </tr>
            </>
        )
    }
    render() {

        if (this.state.openSide == true) {
            if (this.state.searchlength > 0) {
                let j = 0;
                this.state.details1 = this.state.details.filter((i, indexopens) => {
                    if (i.mobileNumber.toString().startsWith(this.state.search) == true) {
                        this.state.indexclosed[j] = indexopens;
                        j++;
                        console.log('inside open indexfind', this.state.indexclosed)
                    }
                    return i.mobileNumber.toString().startsWith(this.state.search)
                })
            }
            else {
                this.state.details1 = this.state.details;
            }
        }
        if (this.state.closedSide == true) {
            if (this.state.searchlength > 0) {
                let j = 0;
                this.state.detailsClosed1 = this.state.detailsClosed.filter((i, indexcloseds) => {
                    // if (i.userMobile.toString().includes(this.state.search) == true) {
                    if (i.userMobile.toString().startsWith(this.state.search) == true) {
                        this.state.indexclosed[j] = indexcloseds;
                        j++;
                        console.log('inside closed indexfind', this.state.indexclosed)
                    }
                    // return i.userMobile.toString().includes(this.state.search)
                    return i.userMobile.toString().startsWith(this.state.search)
                })
            }
            else {
                this.state.detailsClosed1 = this.state.detailsClosed;
            }
        }
        const { details1, currentPage, todosPerPage } = this.state;
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const renderTableDatas = details1.map((data, index) => {
            return (
                this.getDate(data.submitDate) != undefined - Date - undefined &&
                <tr key={index} id="userdata">
                    <td id="col1" className="tabledata">{data.firstName + " " + data.lastName}</td>
                    <td id="col2" className="tabledata">{data.mobileNumber}</td>
                    <td id="col3" className="tabledata">{data.email}</td>
                    <td id="col4" className="tabledata">{data.profileRole.roleType}</td>
                    <td id="col5" className="tabledata">{data.profileRole.roleName}</td>
                    <td id="col6" className="tabledata">{this.getDate(data.submitDate)}</td>
                    <td id="col7" className="preview"><Link
                        to={{
                            pathname: `/OpenItem/${this.state.taskId[index]}`,
                            state: {
                                workflowIndex: this.state.details[index],
                                taskId: this.state.taskId[index]
                            }
                        }}
                        onClick={() => store.dispatch(success(
                            this.state.searchlength > 0 ? this.state.taskId[this.state.indexclosed[index]] : this.state.taskId[index]))}
                    >Pending</Link></td>
                </tr>
            )
        })
        const renderTableData = renderTableDatas.slice(indexOfFirstTodo, indexOfLastTodo);
        const totalPages = Math.ceil(this.state.details1.length / this.state.todosPerPage);
        const previousOff = this.state.currentPage == 1;
        const nextOff = this.state.currentPage == totalPages;
        const { detailsClosed1, currentClosedPage, todosClosedPerPage } = this.state;
        const indexOfLastClosedTodo = currentClosedPage * todosClosedPerPage;
        const indexOfFirstClosedTodo = indexOfLastClosedTodo - todosClosedPerPage;
        const renderClosedTableDatas = detailsClosed1.map((todo, index) => {
            const { firstName, lastName, userMobile, userEmail, userRoleType, roleName, approvalDate, approvalStatus } = todo
            return (
                <>
                    <tr key={index} id="userdata">
                        <td id="col1" className="tabledata">{firstName + " " + lastName}</td>
                        <td id="col2" className="tabledata">{userMobile}</td>
                        <td id="col3" className="tabledata">{userEmail}</td>
                        <td id="col4" className="tabledata">{userRoleType}</td>
                        <td id="col5" className="tabledata">{roleName}</td>
                        <td id="col6" className="tabledata">{this.getDate(approvalDate)}</td>
                        <td id="col7" className="approvalStatus">{approvalStatus}</td>
                    </tr>
                </>
            )
        });
        const renderClosedTableData = renderClosedTableDatas.slice(indexOfFirstClosedTodo, indexOfLastClosedTodo)
        const totalClosedPages = Math.ceil(this.state.detailsClosed1.length / this.state.todosClosedPerPage);
        const previousClosedOff = this.state.currentClosedPage == 1;
        const nextClosedOff = this.state.currentClosedPage == totalClosedPages;
        return (
            <div>
                <MetaDecorator title={TitleDescription.userProfilePageTitle} description={TitleDescription.userProfilePageDescription} />
                {
                    <div className="outer1"><div className="outer1" id="outerdiv">
                        <div className="adhome">
                            <SideNav />
                            <div id="ProfileApprovalPart">
                                <h1 id='userProfiletitle'>User Profile Approval</h1>
                                <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                                    <img alt="View Only Access" src={viewAccess} />
                                    <span className="viewOnly">View Only Access</span>
                                </div>
                                <nav class="navbar navbar-light bg-white" id="openCloseNav">
                                    <div>
                                        <small class="p-2 pb-3" id="open" onClick={this.handleOpenSide}>Open</small>
                                        <small class="p-2 pb-3" id="closed" onClick={this.handleClosedSide}>Closed</small>
                                    </div>
                                    <div>
                                        <small id="searchBy">Search by</small>
                                        <input
                                            className="mobileSearch"
                                            placeholder="Mobile Number"
                                            autoComplete="off"
                                            id="secrchInput"
                                            onChange={this.handlechange}
                                            value={this.state.search}
                                        ></input>
                                        <img id="search_img" src={require('../../../assets/images/search.svg')} width="16" height="16" />
                                    </div>
                                </nav>
                                <div className="contentbox">
                                    <table id='details'>
                                        <tbody>
                                            {this.state.openSide ? this.renderTableHeader() : this.renderClosedTableHeader()}
                                            {this.state.openSide ? renderTableData : renderClosedTableData}
                                        </tbody>
                                    </table>
                                    <hr width="100%" color="#BCBCBC" />
                                    {this.state.openSide ?
                                        <div className="paginationContainer">
                                            <button className={previousOff ? "previousbtnoff" : "previousbtnon"} onClick={this.handleOpenPrevious}>Previous</button>
                                            <small id="page">Page</small>
                                            <small id="currentpage">{this.state.currentPage}</small>
                                            <small id="of">of</small>
                                            <small id="totalpages">{totalPages}</small>
                                            <button className={nextOff ? "nextbtnoff" : "nextbtnon"} onClick={this.handleOpenClick}>Next</button>
                                        </div>
                                        :
                                        <div className="paginationContainer">
                                            <button className={previousClosedOff ? "previousbtnoff" : "previousbtnon"} onClick={this.handleClosedPrevious}>Previous</button>
                                            <small id="page">Page</small>
                                            <small id="currentpage">{this.state.currentClosedPage}</small>
                                            <small id="of">of</small>
                                            <small id="totalpages">{totalClosedPages}</small>
                                            <button className={nextClosedOff ? "nextbtnoff" : "nextbtnon"} onClick={this.handleClosedClick}>Next</button>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div></div>
                }
            </div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(UserProfile);